/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteSkillRequest = {
  skillId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteSkillRequest$inboundSchema: z.ZodType<
  DeleteSkillRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  skill_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "skill_id": "skillId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteSkillRequest$Outbound = {
  skill_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteSkillRequest$outboundSchema: z.ZodType<
  DeleteSkillRequest$Outbound,
  z.ZodTypeDef,
  DeleteSkillRequest
> = z.object({
  skillId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    skillId: "skill_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteSkillRequestToJSON(
  deleteSkillRequest: DeleteSkillRequest,
): string {
  return JSON.stringify(
    DeleteSkillRequest$outboundSchema.parse(deleteSkillRequest),
  );
}
export function deleteSkillRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteSkillRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteSkillRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteSkillRequest' from JSON`,
  );
}
